export default "__VITE_ASSET__C$jVhiRl__"